export default __webpack_public_path__ + "static/media/Confiabilidade-WiFi-3.b4c832e2.jpg";